import FormattedMessage from 'I18n/components/FormattedMessage';
import { useCallback } from 'react';
import { RadioInput } from 'foundations-components/transitional/components/RadioInput';
import { Text } from 'foundations-components/components/Text';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { getCheckedOptionFromView, PUBLIC } from '../../getCheckedOptionFromView';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const PublicRadioOption = ({
  viewUpdates,
  setViewUpdates,
  hasSharedViewPermission = true,
  customSharedViewPermissionErrorMessage
}) => {
  const isChecked = getCheckedOptionFromView(viewUpdates) === PUBLIC;
  const handleChange = useCallback(() => {
    setViewUpdates({
      private: false,
      teamId: undefined
    });
  }, [setViewUpdates]);
  return /*#__PURE__*/_jsx(Tooltip, {
    disabled: hasSharedViewPermission,
    title: customSharedViewPermissionErrorMessage || /*#__PURE__*/_jsx(FormattedMessage, {
      message: "viewsManagement.modals.manageSharing.shareViewEveryoneDisabledTooltip"
    }),
    children: /*#__PURE__*/_jsxs(RadioInput, {
      "data-test-id": `view-sharing-everyone-checked=${isChecked}`,
      disabled: !hasSharedViewPermission,
      checked: isChecked,
      onChange: handleChange,
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "viewsManagement.modals.manageSharing.everyone"
      }), /*#__PURE__*/_jsx(Text, {
        typography: "detail-200",
        color: "text-core-subtle",
        marginBlockStart: "200",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "viewsManagement.modals.manageSharing.everyoneDescription"
        })
      })]
    })
  });
};